import {
  PieChart,
  Pie,
  Cell,
  ResponsiveContainer,
  Legend,
  Tooltip,
} from "recharts";

type ChartData = {
  name: string;
  value: number;
};

interface PieChartComponentProps {
  title: string;
  data: ChartData[];
  colordata: string[]; // hex values without `#`
}

// Custom label inside slices
const renderCustomizedLabel = ({
  cx,
  cy,
  midAngle,
  innerRadius,
  outerRadius,
  value,
}: any) => {
  const RADIAN = Math.PI / 180;
  const radius = innerRadius + (outerRadius - innerRadius) * 0.6;
  const x = cx + radius * Math.cos(-midAngle * RADIAN);
  const y = cy + radius * Math.sin(-midAngle * RADIAN);

  return (
    <text
      x={x + 1}
      y={y + 1}
      fill="white"
      textAnchor="middle"
      dominantBaseline="central"
      fontSize={13}
      fontWeight={700}
    >
      {value}
    </text>
  );
};

// ✅ Custom tooltip component
const CustomTooltip = ({
  active,
  payload,
  colordata,
  data,
}: {
  active?: boolean;
  payload?: any;
  colordata: string[];
  data: ChartData[];
}) => {
  if (active && payload && payload.length) {
    const { name, value } = payload[0].payload;
    const index = data.findIndex((item) => item.name === name);
    const bgColor = `#${colordata[index % colordata.length]}`;

    return (
      <div
        className="rounded px-3 py-1 text-sm text-white font-medium shadow"
        style={{
          backgroundColor: bgColor,
          border: `1px solid ${bgColor}`,
        }}
      >
        {name}: {value}
      </div>
    );
  }
  return null;
};

export default function CircularChart({
  title,
  data,
  colordata,
}: PieChartComponentProps) {
  return (
    <div>
      <h2 className="text-sm font-semibold text-gray-600 mb-4">{title}</h2>

      <div className="bg-white pt-8 px-4 pb-4 rounded-xl shadow w-full">
        <ResponsiveContainer width="100%" height={310}>
          <PieChart>
            <Pie
              data={data}
              dataKey="value"
              nameKey="name"
              cx="50%"
              cy="50%"
              innerRadius={65}
              outerRadius={105}
              labelLine={false}
              label={renderCustomizedLabel}
            >
              {data.map((_, index) => (
                <Cell
                  key={`cell-${index}`}
                  fill={`#${colordata[index % colordata.length]}`}
                />
              ))}
            </Pie>

            {/* ✅ Tooltip added here */}
            {/* <Tooltip
              content={<CustomTooltip colordata={colordata} data={data} />}
            /> */}

            <Legend
              layout="horizontal"
              verticalAlign="bottom"
              align="center"
              iconType="circle"
              iconSize={10}
              wrapperStyle={{
                marginTop: 20,
                paddingTop: 10,
                fontSize: "13px",
                color: "#555",
                fontWeight: 500,
                lineHeight: "20px",
                textAlign: "center",
              }}
            />
          </PieChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
